import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/Header";
import { BottomNav } from "@/components/BottomNav";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service — PataTasks" },
      {
        name: "description",
        content: "Terms of service for PataTasks app and web testing platform.",
      },
    ],
  }),
  component: TermsPage,
});

function TermsPage() {
  const paragraphs = [
    "By using PataTasks, you agree to these terms. PataTasks is a modern app and web testing platform that enables users to earn money by testing digital products for third-party providers.",
    "Testers can browse and accept tests for free. A small maintenance fee is applied to support platform operations, including database infrastructure, development, and ongoing system maintenance. This fee ensures sustainability—we do not profit directly from tester earnings. Withdrawals require a minimum balance of $10.",
    "Test rewards are paid directly to testers upon successful completion. We support mobile money, PayPal, and bank transfers.",
    "Developers should review test submissions carefully. PataTasks is not responsible for the quality of feedback delivered by testers.",
    "Payments are processed via IntaSend. Maintenance fees and withdrawals are handled securely through our payment partners.",
    "Users must not misuse the platform, submit fake test results, or engage in fraudulent activity. Violations may result in account suspension.",
  ];

  return (
    <div className="bg-background pb-20 md:pb-0">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-10">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground mb-4 sm:mb-6">
          Terms of Service
        </h1>
        <div className="space-y-4 sm:space-y-6">
          {paragraphs.map((text, idx) => (
            <p
              key={idx}
              className="rounded-xl border border-blue-200 bg-white p-4 sm:p-5 shadow-sm text-base leading-relaxed text-slate-700"
            >
              {text}
            </p>
          ))}
        </div>
      </div>
      <BottomNav />
    </div>
  );
}
